import apiClient from "./apiClient";

// Función para hacer login
export const loginUser = async (email: string, password: string) => {
    try {
        const response = await apiClient.post("/User/validate", {
            email,
            password,
        });

        return { success: true, user: response.data };
    } catch (error) {
        console.error("Error al iniciar sesión:", error);
        return { success: false };
    }
};

export const forgotPassword = async (email: string) => {
    try {
        await apiClient.put("/User/password/recovery", { sendMail: email });
        return { success: true };
    } catch (error) {
        console.error("Error al recuperar la contraseña:", error);
        return { success: false };
    }
};

export const changePassword = async (newPassword: string, token: string): Promise<{ success: boolean; message?: string }> => {
    try {
        const newPasswordObject = { newPassword: newPassword };
        const config = {
            headers: {
                Authorization: `Bearer ${token}`
            }
        };

        // Usamos apiClient (el que ya tienes importado) pero le inyectamos la config
        const response = await apiClient.put(`/User/password/change`, newPasswordObject, config);

        // Verificar si el mensaje es el esperado
        if (response.data && response.data.message.toString().toLowerCase().includes("éxito") ) {
            return { success: true, message: response.data.message };
        } else {
            throw new Error('Error al cambiar la contraseña');
        }
    } catch (error) {
        console.error('Error al cambiar la contraseña:', error);
        return { success: false };
    }
};